import { LANGUAGES } from "@constants/misc";
import { useMemberSettings } from "@hooks/useMemberSettings";
import { Language, LanguageItem } from "@types";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useLanguages = (): {
  languages: LanguageItem[];
  currentLanguage: LanguageItem;
  changeLanguage: (language: Language) => void;
  isMultiLanguage: boolean;
} => {
  const { languageList = [] } = useMemberSettings();
  const { i18n } = useTranslation();

  const changeLanguage = useCallback(
    (language: Language) => {
      return i18n.changeLanguage(language);
    },
    [i18n],
  );

  const languages = useMemo(() => {
    const availableLanguages = languageList
      ?.map((language) => {
        const languageItem = LANGUAGES.find((lang) => lang.code?.toLowerCase() === language.toLowerCase());
        if (!languageItem) {
          return null;
        }
        return {
          ...languageItem,
        };
      })
      ?.filter((language) => language !== null);

    return availableLanguages?.length ? availableLanguages : LANGUAGES;
  }, [languageList]);

  const currentLanguage = useMemo(() => {
    return languages.find((language) => language?.code === i18n.language) ?? languages[0] ?? LANGUAGES[0];
  }, [i18n.language, languages]);

  return {
    languages: languages as LanguageItem[],
    currentLanguage,
    changeLanguage,
    isMultiLanguage: languages.length > 1,
  };
};
